import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import FixtureCard from './FixtureCard';
import { parseDate } from '../helpers/DateUtils';
import './Landing.css';

const UpcomingFixturesSection = ({ events }) => {
  // Process upcoming fixtures
  const upcomingFixtures = useMemo(() => {
    if (!events || events.length === 0) {
      return [];
    }

    const now = new Date();

    // Filter for future dates only
    let futureEvents = events.filter((event) => {
      try {
        const eventDate = parseDate(event.event_year, event.event_month, event.event_day);
        return eventDate > now;
      } catch (e) {
        return false;
      }
    });

    // Sort by date ascending (earliest first)
    futureEvents = futureEvents.sort((a, b) => {
      try {
        const dateA = parseDate(a.event_year, a.event_month, a.event_day);
        const dateB = parseDate(b.event_year, b.event_month, b.event_day);
        return dateA - dateB; // Ascending order
      } catch (e) {
        return 0;
      }
    });

    // Take first 12 fixtures (displays nicely in 3-column grid)
    futureEvents = futureEvents.slice(0, 12);

    // Determine which fixtures are "Special"
    // Check for keywords like Regional, Championship, Special in event name
    const fixturesWithSpecialFlag = futureEvents.map((event) => {
      const nameUpper = event.event_name ? event.event_name.toUpperCase() : '';
      const isSpecial =
        nameUpper.includes('REGIONAL') ||
        nameUpper.includes('CHAMPIONSHIP') ||
        nameUpper.includes('SPECIAL') ||
        nameUpper.includes('CHRISTMAS');
      return { ...event, isSpecial };
    });

    return fixturesWithSpecialFlag;
  }, [events]);

  return (
    <div className="landing-container">
      <h2 className="section-title">
        <Icon name="calendar outline" />
        Upcoming Fixtures
      </h2>

      {upcomingFixtures.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666', padding: '40px 0' }}>
          No upcoming fixtures at the moment.
        </p>
      ) : (
        <div className="fixtures-grid">
          {upcomingFixtures.map((event) => (
            <FixtureCard key={event.event_id} event={event} isSpecial={event.isSpecial} />
          ))}
        </div>
      )}

      <div className="view-all-link">
        <Link to="/events">View Full Calendar →</Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  events: state.events,
});

export default connect(mapStateToProps)(UpcomingFixturesSection);
